import config from '../assets/google';



export function loadTable1(callback, type) {
  window.gapi.client.load('sheets', 'v4', () => {
    window.gapi.client.sheets.spreadsheets.values.batchGet({
      spreadsheetId: type === 'men' ? config.spreadsheetIdMen : config.spreadsheetIdWomen,
      ranges: ['A6:D6', 'A7:D20']
    })
      .then((response) => {

        const header = response.result.valueRanges[0].values;
        const data = response.result.valueRanges[1].values;

        const headers = header.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3]
        }));

        const dataTable = data.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3]
        }));

        callback({
          headers,
          dataTable
        });
      },
        (response) => {
          callback(false, response.result.error);
        })
  });
}

export function loadTable2(callback, type) {
  window.gapi.client.load('sheets', 'v4', () => {
    window.gapi.client.sheets.spreadsheets.values.batchGet({
      spreadsheetId: type === 'men' ? config.spreadsheetIdMen : config.spreadsheetIdWomen,
      ranges: ['F6:R6', 'F7:R21']
    })
      .then((response) => {
        const header = response.result.valueRanges[0].values;
        const data = response.result.valueRanges[1].values;

        const headers = header.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7],
          value9: item[8],
          value10: item[9],
          value11: item[10],
          value12: item[11],
          value13: item[12],
        }));

        const dataTable = data.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7],
          value9: item[8],
          value10: item[9],
          value11: item[10],
          value12: item[11],
          value13: item[12],
        }));

        callback({
          headers,
          dataTable
        });
      },
        (response) => {
          callback(false, response.result.error);
        })
  });
}

export function loadTable3(callback, type) {
  window.gapi.client.load('sheets', 'v4', () => {
    window.gapi.client.sheets.spreadsheets.values.batchGet({
      spreadsheetId: type === 'men' ? config.spreadsheetIdMen : config.spreadsheetIdWomen,
      ranges: ['F24:R24', 'F25:R39']
    })
      .then((response) => {
        const header = response.result.valueRanges[0].values;
        const data = response.result.valueRanges[1].values;

        const headers = header.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7],
          value9: item[8],
          value10: item[9],
          value11: item[10],
          value12: item[11],
          value13: item[12],
        }));

        const dataTable = data.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7],
          value9: item[8],
          value10: item[9],
          value11: item[10],
          value12: item[11],
          value13: item[12],
        }));

        callback({
          headers,
          dataTable
        });
      },
        (response) => {
          callback(false, response.result.error);
        })
  });
}

export function loadTable4(callback, type) {
  window.gapi.client.load('sheets', 'v4', () => {
    window.gapi.client.sheets.spreadsheets.values.batchGet({
      spreadsheetId: type === 'men' ? config.spreadsheetIdMen : config.spreadsheetIdWomen,
      ranges: ['F42:M42', 'F43:M57']
    })
      .then((response) => {
        const header = response.result.valueRanges[0].values;
        const data = response.result.valueRanges[1].values;

        const headers = header.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7]
        }));

        const dataTable = data.map((item) => ({
          value1: item[0],
          value2: item[1],
          value3: item[2],
          value4: item[3],
          value5: item[4],
          value6: item[5],
          value7: item[6],
          value8: item[7]
        }));

        callback({
          headers,
          dataTable
        });
      },
        (response) => {
          callback(false, response.result.error);
        })
  });
}

